import { DataUtilLocalStorage } from "../../../data/util/LocalStorage";
import { HTMLResizerIndicatorElement } from "../../controlWC/ResizerIndicatorComponent";
import { Table } from "../Tabla";
import { UIUtilElement } from "../../util/Element";

export class TableResizer<TData> {
    private table: Table.Tabla<TData>
    private startResizing: boolean;
    private auxLastCellActive: boolean;

    constructor(table: Table.Tabla<TData>) {
        this.table = table;
        this.startResizing = false;
    }

    private BuildTableColumnsSizesConfigStyle() {
        let style = ``;
        this.table._ColumnsHeaders.forEach(colH => {
            style += `.${this.table._TableIdentifier} .${colH.Field} {
                            width: ${colH.Width};
                            min-width: ${colH.MinWidth};
                            max-width: ${colH.MaxWidth};
                        }\n`
        });

        return style;
    }

    private ApplyColumnSizesConfigStyle() {
        const sizingStyles = this.BuildTableColumnsSizesConfigStyle();
        this.table._BA_SpaceTablaStyleSizing.html(sizingStyles)
    }

    private ApplyGeneralRowsMinWidth(newWidth: number) {
        this.table._BA_DivSpaceTabla.select("style:not(.sizing_table_pref,.table_switch_last_col)")
            .html(`
                                .${this.table._TableIdentifier} .tr_body,
                                .${this.table._TableIdentifier} .rhead>tr,
                                .${this.table._TableIdentifier} .dim_width {
                                    min-width: ${newWidth}px !important;
                                },
                `.trim());
    }

    private SwitchLastCellColCfg(auxLastCellActive: boolean) {
        this.auxLastCellActive = auxLastCellActive;
        let style = ``;
        const gral = `.${this.table._TableIdentifier} > .area_control > .space_tabla`;
        style += `
            ${gral} .rbodyA > tr > td.auxcell-resize,
            ${gral} .rbodyA > tr > th.auxcell-resize,
            ${gral} .rbodyA .tr_body > tr > td.auxcell-resize,
            ${gral} .rbodyA .tr_body > tr > th.auxcell-resize,
            ${gral} .rbodyA .tr_body > tr > tr > td.auxcell-resize,
            ${gral} .rbodyA .tr_body > tr > tr > th.auxcell-resize,
            ${gral} .rbodyB > tr > td.auxcell-resize,
            ${gral} .rbodyB > tr > th.auxcell-resize,
            ${gral} .rbodyB .tr_body > tr > td.auxcell-resize,
            ${gral} .rbodyB .tr_body > tr > th.auxcell-resize,
            ${gral} .rbodyB .tr_body > tr > tr > td.auxcell-resize,
            ${gral} .rbodyB .tr_body > tr > tr > th.auxcell-resize {
                max-width: ${this.auxLastCellActive ? 'unset !important' : ''}
            }
        `;
        this.table._BA_SpaceTablaSwitchLastCellSizing.html(style);
    }

    private UpdateTableColumnDimConfig_LS(columnName: string) {
        const objTableConfigDim = this.table._TableDimCfgLS;
        if (objTableConfigDim[this.table._TableId] && objTableConfigDim[this.table._TableId]["Columns"] && objTableConfigDim[this.table._TableId]["Columns"][columnName]) {
            const column = this.table._ColumnsHeaders.find(d => d.Field == columnName);
            objTableConfigDim[this.table._TableId]["Columns"][columnName]["Width"] = column.Width;
            objTableConfigDim[this.table._TableId]["Columns"][columnName]["MinWidth"] = column.MinWidth;
            objTableConfigDim[this.table._TableId]["Columns"][columnName]["MaxWidth"] = column.MaxWidth;
        }

        let jsonString = JSON.stringify(objTableConfigDim);
        DataUtilLocalStorage._SetItem("winstatus", "tabledimconfig", jsonString);
    }

    private LoadColumnsDimsCfgFromLS() {
        let objTableColumnsDimCfg = this.table._TableDimCfgLS;
        if (!objTableColumnsDimCfg[this.table._TableId]) objTableColumnsDimCfg[this.table._TableId] = {};
        if (!objTableColumnsDimCfg[this.table._TableId]["Columns"]) {
            this.FillColumnsCfg_LS();
            return;
        }
        let hasNewCols = false;

        for (const column of this.table._ColumnsHeaders) {
            const colCfg = objTableColumnsDimCfg[this.table._TableId]["Columns"][column.Field];
            if (!colCfg) {
                hasNewCols = true;
                continue
            };

            const columnWidth = colCfg["Width"];
            const columnMinWidth = colCfg["MinWidth"];
            const columnMaxWidth = colCfg["MaxWidth"];

            if (columnMinWidth) column.Width = columnWidth;
            else console.warn("-d", column.Field, "Prop. Width not found");

            if (columnMinWidth) column.MinWidth = columnMinWidth;
            else console.warn("-d", column.Field, "Prop. MinWidth not found");

            if (columnMaxWidth) column.MaxWidth = columnMaxWidth;
            else console.warn("-d", column.Field, "Prop. MaxWidth not found");
        }

        if (hasNewCols) {
            this.FillColumnsCfg_LS();
        }
    }

    private CalculateDimWidth() {
        const trD = this.table._BAAA_TableHead.select<HTMLTableRowElement>("tr");
        if (!trD.node()) return;
        trD.node()
        this.SwitchLastCellColCfg(false);
        let newWidth = trD.node().scrollWidth;
        const colsWidthSum = Array.from(trD.node().childNodes.values())
            .reduce<number>((sum, childNode: HTMLElement) => {
                return sum + childNode.getBoundingClientRect().width;
            }, 0);
        console.warn({ newWidth, colsWidthSum })
        this.table._BA_DivSpaceTabla.select(".dim_width")
            .style("width", `${newWidth}px`);
        if ((newWidth - this.table._BAAA_TableHead.node().clientWidth) > 1) {
            this.Page_ApplyScrollX();
            this.table._IsColumnsResizable && this.ApplyGeneralRowsMinWidth(newWidth);
        } else {
            this.table._IsColumnsResizable && this.ApplyGeneralRowsMinWidth(this.table._ConfigMinWidth);
        }

        if (!this.table._IsColumnsResizable) return;
        const trHeadWidth = Array.from(trD.node().childNodes.values())
            .reduce<number>((sum, childNode: HTMLElement) => {
                return sum + childNode.getBoundingClientRect().width;
            }, 0);
        const dif = newWidth - trHeadWidth;
        (dif > 1) && this.SwitchLastCellColCfg(true);
    }

    private FillColumnsCfg_LS() {
        let objTableDimConfig = this.table._TableDimCfgLS;
        if (!objTableDimConfig[this.table._TableId]) {
            objTableDimConfig[this.table._TableId] = {};
        }
        objTableDimConfig[this.table._TableId]["Columns"] = {};
        this.table._ColumnsHeaders.forEach(d => {
            objTableDimConfig[this.table._TableId]["Columns"][d.Field] = {};
            objTableDimConfig[this.table._TableId]["Columns"][d.Field]["Width"] = d.Width;
            objTableDimConfig[this.table._TableId]["Columns"][d.Field]["MinWidth"] = d.MinWidth;
            objTableDimConfig[this.table._TableId]["Columns"][d.Field]["MaxWidth"] = d.MaxWidth;
        })
        let jsonString = JSON.stringify(objTableDimConfig);
        DataUtilLocalStorage._SetItem("winstatus", "tabledimconfig", jsonString);
    }

    /** 
     * Observa el evento de redimensión de la tabla
     * independientemente de si la tabla utiliza la config Resizable para sus columnas
    */
    private TableResizeObserver() {
        let lastWidth: number;
        let resizeObserver = UIUtilElement._GetResizeObserver(() => {
            let trD = this.table._BAAA_TableHead.select<HTMLTableRowElement>("tr");
            if (trD.node()) {
                this.SwitchLastCellColCfg(false);
                let newWidth = trD.node().scrollWidth;
                if (lastWidth != newWidth) {
                    lastWidth = newWidth;
                    this.table._BA_DivSpaceTabla.select(".dim_width")
                        .style("width", lastWidth + "px");
                    if ((lastWidth - this.table._BAAA_TableHead.node().clientWidth) > 1) {
                        this.Page_ApplyScrollX();
                        this.table._IsColumnsResizable && this.ApplyGeneralRowsMinWidth(lastWidth);
                    } else {
                        this.table._IsColumnsResizable && this.ApplyGeneralRowsMinWidth(this.table._ConfigMinWidth);
                    }
                }
                if (this.table._IsColumnsResizable) {
                    const trHeadWidth = Array.from(trD.node().childNodes.values())
                        .reduce<number>((sum, childNode: HTMLElement) => {
                            return sum + childNode.getBoundingClientRect().width
                        }, 0);

                    const dif = lastWidth - trHeadWidth;
                    (dif > 1) && this.SwitchLastCellColCfg(true);
                }
            }
        });
        resizeObserver.observe(this.table._BA_DivSpaceTabla.node());
    }

    private TableMutationObserver() {
        const trD = this.table._BAAA_TableHead.select<HTMLTableRowElement>("tr").node();
        if (!trD) return;
        let mutationTimeOut: NodeJS.Timeout;

        const mutationObserver = new MutationObserver(() => {
            if (mutationTimeOut) {
                clearTimeout(mutationTimeOut);
            }

            mutationTimeOut = setTimeout(() => {
                console.log("MutationObserver")
                this.CalculateDimWidth();
                mutationTimeOut = null;
                mutationObserver.disconnect();
            }, 50);
        });

        const config = {
            childList: true,       // Observa si se añaden/quitan <th>
            subtree: true,         // Observa cambios en descendientes (contenido dentro del <th>)
            characterData: true,   // Observa cambios en texto
            attributes: true       // Observa cambios en atributos (p.ej. `style`, `class`)
        };

        mutationObserver.observe(trD, config);
    }

    private Page_ApplyScrollX() {
        let elem = this.table._BA_DivSpaceTabla.node();
        this.table._BAAA_TableHead.node().scrollLeft = elem.scrollLeft;
        this.table._BAAA_TableBodyA.node().scrollLeft = elem.scrollLeft;
        this.table._BAAA_TableBodyB.node().scrollLeft = elem.scrollLeft;
    }

    public _AttachResizer(th: TSelectionHTML<"th">, tr: TSelectionHTML<"tr">, datum: Table.ITableField<TData>) {
        let resizer = th.select<HTMLResizerIndicatorElement>("wc-resizer");

        if (!resizer.node()) {
            resizer = th.append<HTMLResizerIndicatorElement>("wc-resizer")
                .classed(".resizer", true);
        }

        let resizerTimeOut: NodeJS.Timeout;
        resizer
            .attr("min", datum.OriginalMinWidth.replace("px", ""))
            .attr("init-dim", datum.OriginalMinWidth.replace("px", ""));

        resizer.node()._OnStartSizing = () => {
            tr.classed("sizing", true);
        }

        resizer.node()._OnEndSizing = () => {
            setTimeout(() => {
                tr.classed("sizing", false);
            });
        }

        resizer.node()._OnResize = (e) => {
            if (!this.startResizing) this.startResizing = true;
            if (resizerTimeOut) {
                clearTimeout(resizerTimeOut);
                resizerTimeOut = null;
            }
            resizerTimeOut = setTimeout(() => {
                this.SwitchLastCellColCfg(false);
                resizerTimeOut = null;
                const i = this.table._ColumnsHeaders.findIndex(d => d.Field == datum.Field);
                this.table._ColumnsHeaders[i].Width = e.detail.Width + "px";
                this.table._ColumnsHeaders[i].MinWidth = e.detail.Width + "px";
                this.table._ColumnsHeaders[i].MaxWidth = e.detail.Width + "px";

                this.ApplyColumnSizesConfigStyle();
                th.style("width", null);
                th.style("min-width", null);
                th.style("max-width", null);

                const trHeadWidth = Array.from(tr.node().childNodes.values()).reduce((sum, childNode: HTMLElement) => sum + childNode.getBoundingClientRect().width, 0);
                const dif = trHeadWidth - this.table._BA_DivSpaceTabla.node().clientWidth;
                if (dif > 1) {
                    this.table._BA_DivSpaceTabla.select<HTMLDivElement>(".dim_width").style("width", (this.table._BA_DivSpaceTabla.node().clientWidth + dif) + "px");
                    this.ApplyGeneralRowsMinWidth(this.table._BA_DivSpaceTabla.node().clientWidth + dif);
                } else if (dif < -1) {
                    this.SwitchLastCellColCfg(true);
                    this.table._BA_DivSpaceTabla.select<HTMLDivElement>(".dim_width").style("width", (this.table._BA_DivSpaceTabla.node().clientWidth) + "px");
                    this.ApplyGeneralRowsMinWidth(this.table._ConfigMinWidth);
                }
                this.UpdateTableColumnDimConfig_LS(datum.Field);
            }, 200)
        }
    }

    public _AppendAuxCellResize(parent: TSelectionHTML<"htmlelement">) {
        parent.append<HTMLTableCellElement>("td")
            .classed("auxcell-resize", true);
    }

    public _SwitchLastCellCol(auxLastCellActive: boolean) {
        this.SwitchLastCellColCfg(auxLastCellActive);
    }

    public _ResetColumnsDimensions() {
        const tableColumnsCfg = this.table._InfoColumns;
        tableColumnsCfg.forEach(d => {
            const i = this.table._ColumnsHeaders.findIndex(col => d.Field == col.Field);
            this.table._ColumnsHeaders[i].Width = d.Width;
            this.table._ColumnsHeaders[i].MinWidth = d.MinWidth;
            this.table._ColumnsHeaders[i].MaxWidth = null;
        });
        this.ApplyColumnSizesConfigStyle();
        this.FillColumnsCfg_LS();
        this._SwitchLastCellCol(false);
        this.ApplyGeneralRowsMinWidth(this.table._ConfigMinWidth);
        let trD = this.table._BAAA_TableHead.select<HTMLTableRowElement>("tr");
        if (trD.node()) {
            let newWidth = trD.node().scrollWidth;
            this.table._BA_DivSpaceTabla.select(".dim_width")
                .style("width", newWidth + "px");
        }
    }

    public _TableResizeStartObserver() {
        this.TableResizeObserver();
        this.TableMutationObserver();
    }

    public _TableApplyScrollX() {
        this.Page_ApplyScrollX();
    }

    public _LoadColumnsDimensionsCfgFromLS() {
        this.LoadColumnsDimsCfgFromLS();
    }

    public _BuildSizeStylesConfig() {
        this.ApplyColumnSizesConfigStyle();
    }

    public _ApplyGeneralRowsMinWidth(minWidth: number) {
        this.ApplyGeneralRowsMinWidth(minWidth);
    }
}